/* eslint-disable */
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getRiders = createAsyncThunk('getRiders', async (params, { rejectWithValue }) => {
  return await axios({
    method: 'get',
    url: `api/riders`,
    params: params,
    baseURL: process.env.REACT_APP_API_BASE_URL,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return rejectWithValue(error.response.data);
    });
});

export const createRider = createAsyncThunk('createRider', async (params, { rejectWithValue }) => {
  return await axios({
    data: params,
    method: 'post',
    url: `api/riders`,
    baseURL: process.env.REACT_APP_API_BASE_URL,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return rejectWithValue(error.response.data);
    });
});

export const findRider = createAsyncThunk('findRider', async (params, { rejectWithValue }) => {
  return await axios({
    data: params,
    method: 'post',
    url: `api/merchant/search-rider`,
    baseURL: process.env.REACT_APP_API_BASE_URL,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return rejectWithValue(error.response.data);
    });
});

export const skipRider = createAsyncThunk('skipRider', async (params, { rejectWithValue }) => {
  return await axios({
    data: params,
    method: 'post',
    url: `api/rider/skip-order`,
    baseURL: process.env.REACT_APP_API_BASE_URL,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return rejectWithValue(error.response.data);
    });
});

export const getRiderDetails = createAsyncThunk(
  'getRiderDetails',
  async (id, { rejectWithValue }) => {
    return await axios({
      method: 'get',
      url: `api/riders/${id}`,
      baseURL: process.env.REACT_APP_API_BASE_URL,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return rejectWithValue(error.response.data);
      });
  },
);

export const getRiderDeliveries = createAsyncThunk(
  'getRiderDeliveries',
  async (params, { rejectWithValue }) => {
    return await axios({
      method: 'get',
      params: params,
      url: `api/rider/earnings`,
      baseURL: process.env.REACT_APP_API_BASE_URL,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return rejectWithValue(error.response.data);
      });
  },
);

export const deleteRider = createAsyncThunk('deleteRider', async (id, { rejectWithValue }) => {
  return await axios({
    method: 'delete',
    url: `api/riders/${id}`,
    baseURL: process.env.REACT_APP_API_BASE_URL,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return rejectWithValue(error.response.data);
    });
});

// export const samplePutAPI = createAsyncThunk(
//   'samplePutAPI',
//   async (params, { rejectWithValue }) => {
//     return await axios({
//       method: 'put',
//       url: `sample-url`,
//       data: params,
//       baseURL: process.env.REACT_APP_API_BASE_URL,
//     })
//       .then((response) => {
//         return response.data;
//       })
//       .catch((error) => {
//         return rejectWithValue(error.response.data);
//       });
//   },
// );
